import { invitationGuid } from './screens/invite/actions';
import { changeCurrentCase } from './screens/cases/actions';
import { markNotificationAsRead } from './screens/notifications/actions';
import {
  setNavMode,
  changeCurrentTopic,
  brodcastNotificationTapped,
} from './screens/messaging/actions';
import navModes from './screens/messaging/nav_modes';

import { store } from './store';

import { InteractionManager, Platform } from 'react-native';
import Utils from './utils';
import I18n from './I18n';
import Navigation from './navigation';
import { getJsonFile } from './services/fileService';
import VersionNumber from './VersionNumber';
import { env, S3_PUBLIC_BUCKET_URL } from './constants/env';
import { __WEB__ } from './constants/styles';

import {
  NEW_INVITE_NOTIFICATION,
  NEW_EMPLOYER_INVITE_NOTIFICATION,
  SEND_INVITE_NOTIFICATION,
  EDIT_EVENT_NOTIFICATION,
  NEW_EVENT_NOTIFICATION,
  MISS_EVENT_NOTIFICATION,
  DELETE_EVENT_NOTIFICATION,
  CALENDAR_EVEVENTASSIGNMENT,
  CALENDAR_EMPLOYER_CHANGE_STATE,
  CALENDAR_EMPLOYER_PUBLISH_TO_CASES,
  TEST_RESOURCE,
  CALENDAR_UPCOMING_ON_CALL,
  CALENDAR_ON_CALL,
  MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION,
  MESSAGING_NEW_BROADCAST_NOTIFICATION,
} from './notificationsHandlersTypes';

const notificationReceivedHandlers = [];

export function registerNotificationReceivedHandler(handler) {
  notificationReceivedHandlers.push(handler);
  // console.log('registerNotificationReceivedHandler registered handler at index', notificationReceivedHandlers.indexOf(handler), notificationReceivedHandlers);
}
export function unRegisterNotificationReceivedHandler(handler) {
  let index = notificationReceivedHandlers.indexOf(handler);
  if (index > -1) {
    notificationReceivedHandlers.splice(index, 1);
  }

  // console.log('unregisterNotificationReceivedHandler', notificationReceivedHandlers)
}

export function handleNotificationReceived(message) {
  // for now just stop if we find any handler that returns true
  // indicating that it has handled the notification
  // we can make this fancier in future if needed
  for (let handler of notificationReceivedHandlers) {
    if (handler(message)) return true;
  }

  return false;
}

// *Note - this must be called after any call to Navigation.handleDeepLink
// that will switch tabs otherwise the drawer gets confused when closing
// and ends up remaining open with a weird black background (iOS only)
function _closeDrawerAndModalsAfterTabSwitch() {
  Navigation.dismissAllModals();
  Navigation.closeDrawer();
}

function _handleNotification(dispatch, message) {
  InteractionManager.runAfterInteractions(() => {
    let data = message.data;
    let type = data.resource;
    if (data.campaignId && Platform.OS === 'ios') {
      Utils.trackCampaign(data.campaignId, data.source);
    }

    let skipMarkAsRead = false;
    switch (type) {
      case CALENDAR_UPCOMING_ON_CALL:
      case CALENDAR_ON_CALL:
        Navigation.handleDeepLink({
          link: 'employer/main',
          payload: { notification: data },
        });
        // change this when we use the custom oncall notification popup in native
        skipMarkAsRead = !!__WEB__;
        if (!__WEB__) _closeDrawerAndModalsAfterTabSwitch();
        break;
      case NEW_INVITE_NOTIFICATION:
      case NEW_EMPLOYER_INVITE_NOTIFICATION:
        dispatch(invitationGuid(data.guid));
        Navigation.showModal({
          screen: 'InviteAccept',
          title: I18n.ac('invite.invitation'),
          passProps: {
            notificationId: data.notificationId,
          },
        });
        skipMarkAsRead = true;
        break;
      case SEND_INVITE_NOTIFICATION:
        Navigation.showModal({
          screen: 'Invite',
          title: I18n.ac('invite.invitePeople'),
          animationType: 'slide-up',
        });
        break;
      case EDIT_EVENT_NOTIFICATION:
      case NEW_EVENT_NOTIFICATION:
      case CALENDAR_EVEVENTASSIGNMENT:
        dispatch(changeCurrentCase(data.caseId, { currentEventId: data.eventId }));
        Navigation.handleDeepLink({
          link: 'calendar/main',
        });
        break;
      case MISS_EVENT_NOTIFICATION:
        const options = {
          shouldScrollToDate: data.startDate,
        };
        dispatch(changeCurrentCase(data.caseId, options));
        Navigation.handleDeepLink({
          link: 'calendar/main',
        });
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      case DELETE_EVENT_NOTIFICATION:
        dispatch(changeCurrentCase(data.caseId));
        Navigation.handleDeepLink({
          link: 'calendar/main',
        });
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      case MESSAGING_NEW_GROUP_MESSAGE_NOTIFICATION:
        if (data.caseId) {
          dispatch(changeCurrentCase(data.caseId, { currentTopicId: data.topicId }));
          dispatch(setNavMode(navModes.CASE));
          // should change also currentMessageId?
        } else {
          dispatch(changeCurrentTopic(parseInt(data.topicId)));
        }
        Navigation.handleDeepLink({
          link: 'messaging/main',
        });
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      case MESSAGING_NEW_BROADCAST_NOTIFICATION:
        dispatch(brodcastNotificationTapped());
        break;
      case CALENDAR_EMPLOYER_CHANGE_STATE:
        Navigation.handleDeepLink({
          link: 'employerCalendar/main',
        });
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      case CALENDAR_EMPLOYER_PUBLISH_TO_CASES:
        dispatch(changeCurrentCase(data.caseId));
        Navigation.handleDeepLink({
          link: 'calendar/main',
        });
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      case TEST_RESOURCE:
        Navigation.handleDeepLink({
          link: 'messaging/main',
        });
        skipMarkAsRead = true;
        _closeDrawerAndModalsAfterTabSwitch();
        break;
      default:
        if (data && data.caseId) {
          dispatch(changeCurrentCase(data.caseId));
        }
        _closeDrawerAndModalsAfterTabSwitch();
    }
    if (!skipMarkAsRead) dispatch(markNotificationAsRead(data.notificationId));
  });
}

export function handleNotification(message, isAppLaunch) {
  // console.info('notificationsHandlers handleNotification', notification);

  // Navigation.dismissAllModals();
  // stupid timeout in case the call to _handleNotification triggers a new
  // modal to be presented as in the case of showing the InviteAccept modal.
  // the call to Navigation.dismissAllModals(); was causing a new modal to also
  // be dismissed in spite of the user of InteractionManager being used in
  // _handleNotification
  // setTimeout(() => {
  _handleNotification(store.dispatch, message);
  // }, 1000);

  // // if there is a visible modal currently we'll need to dismiss it in order
  // // to handle the noticication tap. First verify with the user in case they
  // // have unsaved data. This can be much fancier in terms of handling certain
  // // modals differently, but this will be an improvement for now
  // if (Navigation.currentlyVisibleModalScreen()) {
  //   Alert.alert(
  //     'Leave Screen?',
  //     'Do you want to leave this screen? Any unsaved data will be lost.',
  //     [
  //       { text: 'Cancel', onPress: () => {}, style: 'cancel' },
  //       {
  //         text: 'Leave',
  //         onPress: () => {
  //           Navigation.close(this.props);
  //           _handleNotification(dispatch, notification);
  //         },
  //       },
  //     ],
  //     { cancelable: false }
  //   );
  // } else {
  //   _handleNotification(dispatch, notification);
  // }
}

export function displayNotification(message) {
  // Uncommnet for testing
  // console.info('displayNotification', message);
  // message = {
  //   notification: {
  //     body:
  //       'Lorien changed Hlkjhljjjj in case Case Numba 1 to Oct 25, 2018, 4:00 PM PDT',
  //     title: 'Lorien changed an event on Case Numba 1',
  //   }
  //   data: {
  //     caseId: '3',
  //     eventId: '391',
  //     notificationId: '1456',
  //     resource: 'TEST_RESOURCE',
  //   },
  // };

  // message.notification is for notifications that will be displayed.
  // if no notifiication is present, this is a data only notification,
  // pass it through to the handler
  if (!message.notification) {
    handleNotification(message);
  }

  Navigation.showInAppNotification({
    screen: 'NotificationPopup',
    passProps: {
      notification: message.notification,
      handlePress: () => {
        // console.info('displayNotification handlePress', notification);
        handleNotification(message);
      },
      autoDismissTimerSec: 5,
    },
  });
}

export function handleNotificationInForeground(message) {
  if (handleNotificationReceived(message)) return;

  if (message.notification) {
    // popup notification
    displayNotification(message);
  } else {
    // data only notification
    handleNotification(message);
  }
}

export function checkAndDisplayNewAppVersion() {
  if (__WEB__) return Promise.resolve();
  // Uncommnet for testing
  // Navigation.showInAppNotification({
  //   screen: 'NewAppVersionPopup',
  //   passProps: {
  //     // can't just pass whole notification object because its not simple/serializable
  //     message: 'test',
  //     link: null,
  //     autoDismissTimerSec: 60, // auto dismiss notification in seconds
  //   }, // simple serializable object that will pass as props to the in-app notification (optional)
  // });

  return getJsonFile(`${env(S3_PUBLIC_BUCKET_URL)}op-app/appVersion.json`)
    .then((json) => {
      if (json) {
        let latestAppVersion = json[Platform.OS];
        if (latestAppVersion && newAppVersionAvailable(latestAppVersion, VersionNumber)) {
          let message = latestAppVersion.message || json.message;
          Navigation.showInAppNotification({
            screen: 'NewAppVersionPopup',
            passProps: {
              // can't just pass whole notification object because its not simple/serializable
              message: message,
              link: latestAppVersion.link,
              autoDismissTimerSec: 60, // auto dismiss notification in seconds
            }, // simple serializable object that will pass as props to the in-app notification (optional)
          });
        }
      }
    })
    .catch((error) => {
      console.error('checkAndDisplayNewAppVersion error', error);
    });
}

function newAppVersionAvailable(latest, current) {
  const semver = require('semver');
  return semver.gt(latest.appVersion, current.appVersion);
}
